"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpWidgetChart = void 0;
const tmpls_1 = require("./tmpls");
const App_1 = require("../App");
class CmpWidgetChart extends tmpls_1.CmpWidgetChartBase {
    constructor() {
        super();
        this._loadAsync();
    }
    _loadAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            yield App_1.App.Inst.awaitTime(500);
            const symbol = this.ctrls.chart.getData('symbol');
            const interval = '5min';
            const container = this.ctrls.chart;
            if (!container)
                return;
            container.html = '';
            let style = {
                textColor: '#7072A2',
                background: '#080926'
            };
            const chartOptions = {
                autoSize: true,
                layout: { textColor: style.textColor, background: { type: 'solid', color: style.background } },
                timeScale: {
                    timeVisible: true,
                    secondsVisible: false,
                },
                grid: {
                    vertLines: {
                        color: '#242548',
                        style: 0, // 0 — solid, 1 — dashed, 2 — dotted
                    },
                    horzLines: {
                        color: '#242548',
                        style: 0,
                    },
                }
            };
            const chart = globalThis.LightweightCharts.createChart(container.el, chartOptions);
            const candlestickSeries = chart.addCandlestickSeries({
                upColor: '#04C9A1', downColor: '#B90042', borderVisible: false,
                wickUpColor: '#04C9A1', wickDownColor: '#B90042',
                priceFormat: {
                    type: 'price',
                    //  precision: 1,
                    minMove: 0.0000001
                }
            });
            const dataResponce = yield fetch("https://plusx.app/stats/" + symbol + "/candles_" + interval);
            const data = yield dataResponce.json();
            for (const d of data) {
                d.time = d.timestamp;
            }
            candlestickSeries.setData(data);
            chart.timeScale().fitContent();
        });
    }
}
exports.CmpWidgetChart = CmpWidgetChart;
//# sourceMappingURL=CmpWidgetChart.js.map